import './ConsentAvatar.scss'
import React from 'react'
import { UserConsentState } from './model'
import { getInitials } from '../../views/utils'
import { ReactComponent as UserShield } from '../../assets/images/user-shield.svg'

interface ConsentAvatarProps extends React.ComponentPropsWithoutRef<'div'> {
  name: string
  consentState?: UserConsentState
}

export const ConsentAvatar: React.FC<ConsentAvatarProps> = ({ className, name, consentState, ...rest }) => {
  return (
    <div className={`consent-avatar d-flex justify-content-center align-items-center position-relative ${className ? className : ''}`} {...rest}>
      <div className='zocks-text-white'>{getInitials(name)}</div>
      {consentState ? (
        <div className='position-absolute top-0 end-0' style={{ transform: 'translate(25%, -25%)' }}>
          <div className={`shield-badge d-flex justify-content-center align-items-center shield-badge-${consentState}`}>
            <UserShield fill='white' width={10} height={10} />
          </div>
        </div>
      ) : null}
    </div>
  )
}
